export default {
	echartsInstance: [],
	/**
	 * @param {Object} echartNode
	 * 根据传入节点 更新opt数据
	 * 
	 */
	upEchartOpt: function(echartNode) {
		const _this = this;
		if (echartNode == null) {
			for (let i = 0; i < _this.echartsInstance.length; i++) {
				console.log(_this.echartsInstance[i].root)
				console.log(_this.echartsInstance[i].node)
				_this.echartsInstance[i].opt.xAxis.data = _this.echartsInstance[i].root.TimePoins
				_this.echartsInstance[i].opt.legend.data = _this.echartsInstance[i].root.legend_data
				_this.echartsInstance[i].name.setOption(_this.echartsInstance[i].opt);
			}
		} else {
			for (let i = 0; i < _this.echartsInstance.length; i++) {
				if (_this.echartsInstance[i].node == echartNode) {
					console.log("_this.echartsInstance[i].root.TimePoins")
					console.log(_this.echartsInstance[i].node)
					console.log(_this.echartsInstance[i].root.TimePoins)
					_this.echartsInstance[i].name.setOption(_this.echartsInstance[i].opt);
					_this.echartsInstance[i].opt.xAxis.data = _this.echartsInstance[i].root.TimePoins
					_this.echartsInstance[i].opt.legend.data = _this.echartsInstance[i].root.legend_data
				}
			}
		}
	},

	/***
	传入节点
	销毁实例	
	**/
	disposeEchart: function(echartNode) {
		const _this = this;
		if (echartNode == null) {
			for (let i = 0; i < _this.echartsInstance.length; i++) {
				_this.echartsInstance[i].name.dispose();
				//_this.echartsInstance.splice(i, 1);
			}
			_this.echartsInstance = []
		} else {
			for (let i = 0; i < _this.echartsInstance.length; i++) {
				if (_this.echartsInstance[i].node == echartNode) {
					_this.echartsInstance[i].name.dispose();
					_this.echartsInstance.splice(i, 1);
				}
			}
		}
	},
	/**
	 * 
	 * 实例刷新
	 * 
	 * 
	 * **/
	resizeEchart: function(echartNode) {
		const _this = this;
		if (echartNode == null) {
			console.log("zhix")
			for (let i = 0; i < _this.echartsInstance.length; i++) {
				_this.echartsInstance[i].name.resize();
			}
		} else {
			for (let i = 0; i < _this.echartsInstance.length; i++) {
				if (_this.echartsInstance[i].node == echartNode) {
					_this.echartsInstance[i].name.resize();
				}
			}
		}
	},

	/**
	 * 初始化echart图表，返回echart对象
	 * @param {Object} echartNode
	 * 示例 两条线
seriesData: [{
							name: '邮件营销',
							type: 'line',
							stack: '总量',
							data: [120, 132, 101, 134, 90, 230, 210]
						},
						{
							name: '联盟广告',
							type: 'line',
							stack: '总量',
							data: [220, 182, 191, 234, 290, 330, 310]
						},
						{
							name: '视频广告',
							type: 'line',
							stack: '总量',
							data: [150, 232, 201, 154, 190, 330, 410]
						},
						{
							name: '直接访问',
							type: 'line',
							stack: '总量',
							data: [320, 332, 301, 334, 390, 330, 320]
						},
						{
							name: '搜索引擎',
							type: 'line',
							stack: '总量',
							data: [820, 932, 901, 934, 1290, 1330, 1320]
						}
					],
					legend_data: ['邮件营销','邮件营销','邮件营销','邮件营销','邮件营销']，
					style: {
						color: "black"
					},
					TimePoins: []
	 * 
	 * 
	 */
	initLinechart: function(echartNode, _this) {
		let myDate = new Date();
		console.log(myDate);
		const echartDate2 = [];
		for (let i = 11; i >= 0; i--) {
			echartDate2.push((myDate.getMonth() + 1) + "-" + myDate.getDate());
			myDate = new Date(myDate -= 24 * 60 * 60 * 1000);
		}
		echartDate2.reverse();

		const option = {
			title: {
				//text: "各阶段测试情况",
				textStyle: {
					color: 'rgba(0, 0, 0, 1.0)'
				},
			},
			tooltip: {
				trigger: 'axis',

				backgroundColor: 'rgba(50,50,50,0.5)',
				borderWidth: '1',
				borderColor: 'rgba(85, 255, 127, 1)',
				textStyle: {
					color: 'rgba(85, 255, 127, 1)',
					fontWeight: 'bold'
				}
			},
			legend: {
				data: _this.legend_data,
				textStyle: {
					color: _this.style.color
				},
				scroll: 'scroll'
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			toolbox: {
				feature: {
					saveAsImage: {}
				}
			},
			textStyle: {
				color: _this.style.color
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: _this.TimePoins
			},
			yAxis: [{
					type: 'value',
					name: '充电次数',
					position: 'left',
					axisLine: {
						show: true,
						lineStyle: {
							color: _this.color
						}
					},
					axisLabel: {
						formatter: '{value}'
					}
				},
				{
					type: 'value',
					name: '充电电量',
					position: 'right',
					axisLine: {
						show: true,
						lineStyle: {
							color: _this.color
						}
					},
					axisLabel: {
						formatter: '{value}'
					}
				}
			],
			series: _this.seriesData
		};
		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		myChart.setOption(option);
		myChart.resize();
		let a = new Object();
		a.name = myChart;
		a.opt = option;
		a.node = echartNode;
		a.root = _this
		this.echartsInstance.push(a)
		return myChart;
	},
	/* 
	 *没有双y轴线图
	 *
	 *
	 */
	initLinechart2: function(echartNode, _this) {
		let myDate = new Date();
		console.log(myDate);
		const echartDate2 = [];
		for (let i = 11; i >= 0; i--) {
			echartDate2.push((myDate.getMonth() + 1) + "-" + myDate.getDate());
			myDate = new Date(myDate -= 24 * 60 * 60 * 1000);
		}
		echartDate2.reverse();
		const option = {
			title: {
				//text: "各阶段测试情况",
				textStyle: {
					color: 'rgba(0, 0, 0, 1.0)'
				},
			},
			tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(50,50,50,0.5)',
				borderWidth: '1',
				borderColor: 'rgba(85, 255, 127, 1)',
				textStyle: {
					color: 'rgba(85, 255, 127, 1)',
					fontWeight: 'bold'
				}
			},
			legend: {
				data: _this.legend_data,
				textStyle: {
					color: _this.style.color
				},
				scroll: 'scroll'
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			toolbox: {
				feature: {
					saveAsImage: {}
				}
			},
			textStyle: {
				color: _this.style.color
			},
			xAxis: {
				type: 'category',
				//boundaryGap: false,
				data: _this.TimePoins
			},
			yAxis: [{
					type: 'value',
					name: '人数',
					axisLabel: {
						formatter: '{value}'
					}
				}
			],
			series: _this.seriesData
		};
		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		myChart.setOption(option);
		myChart.resize();
		let a = new Object();
		a.name = myChart;
		a.opt = option;
		a.node = echartNode;
		a.root = _this
		this.echartsInstance.push(a)
		return myChart;
	},
	//统计分析那里用这个
	initLinechart3: function(echartNode, _this) {
		let myDate = new Date();
		console.log(myDate);
		const echartDate2 = [];
		for (let i = 11; i >= 0; i--) {
			echartDate2.push((myDate.getMonth() + 1) + "-" + myDate.getDate());
			myDate = new Date(myDate -= 24 * 60 * 60 * 1000);
		}
		echartDate2.reverse();
		const title = _this.TimePoins < 1 ? {
			text: '暂无数据',
			x: 'center',
			y: 'center',
			textStyle: {
				fornSize: 14,
				fontWeight: 'normal',
			}
		} : {
			textStyle: {
				color: 'rgba(0, 0, 0, 1.0)'
			},
		};
		let option = {
			title: title,
			tooltip: {
				trigger: 'axis',
				textStyle: {
					align: 'left'
				},
			},
			legend: {
				data: _this.legend_data,
				textStyle: {
					color: _this.style.color
				},
				scroll: 'scroll'
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			toolbox: {
				feature: {
					saveAsImage: {}
				}
			},
			textStyle: {
				color: _this.style.color
			},
			xAxis: {
				type: 'category',
				//boundaryGap: false,
				data: _this.TimePoins
			},
			yAxis: [{
					type: 'value',
					axisLabel: {
						formatter: '{value}'
					}
				}
			],
			series: _this.seriesData
		};

		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		myChart.setOption(option);
		myChart.resize();
		let a = new Object();
		a.name = myChart;
		a.opt = option;
		a.node = echartNode;
		a.root = _this
		this.echartsInstance.push(a)
		return myChart;
	},
	initLineChartEmpry: function(echartNode) {
		const option = {
			title: {},
			TimePoins: [],
			legend_data: null,
			xAxis: {
				type: 'category',
				data: [],
			},
			legend: {
				data: null,
				textStyle: {
					color: "black"
				},
				scroll: 'scroll'
			},
			style: {
				color: "black"
			},
		};
		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		myChart.setOption(option);
		myChart.resize();
		let a = new Object();
		a.name = myChart;
		a.opt = option;
		a.node = echartNode;
		a.root = option
		this.echartsInstance.push(a)
		return myChart;
	},

	/**
	 * 饼图
	 * @param {Object} echartNode
	 * @param {Object} seriesData
	 * @param {Object} _this
	 * 				pieMap: {
					series: [{
							value: 12,
							name: this.$t('label_disposed')
						},
						{
							value: 76,
							name: this.$t('label_pending')
						}
					],
					legend_data: [this.$t('label_disposed'),this.$t('label_pending')]
				},
	 * 
	 * 
	 */
	initPiechart: function(echartNode, seriesData, _this) {
		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		const option = {
			title: {
				text: [
					'{a|' + seriesData.totalNum + '}',
					'{b|总数}'
				].join('\n'),
				x: 'center',
				y: 'center',
				textStyle: {
					color: "white",
					rich: {
						a: {
							color: '#ffffff',
							fontSize: 30,
							fontWeight: 'bold',
							lineHeight: 40,
						},
						b: {
							color: '#55ff7f',
							lineHeight: 20
						},
					}
				}
			},
			tooltip: {
				trigger: 'item',
				formatter: '{a} <br/>{b}: {c} ({d}%)',
				backgroundColor: 'rgba(50,50,50,0.5)',
				borderWidth: '1',
				borderColor: 'rgba(85, 255, 127, 1)',
				textStyle: {
					color: 'rgba(85, 255, 127, 1)',
					fontWeight: 'bold'
				},
				position: [10, 10]
			},
			legend: {
				show: false,
				type: 'scroll',
				orient: 'horizontal',
				left: 1,
				data: seriesData.legend_data,
				textStyle: {
					color: 'rgba(85, 255, 127, 1)'
				},
				pageIconColor: '#00ff7f',
				pageIconInactiveColor: '#ff0000',
				pageTextStyle: {
					color: '#ffffff'
				}
			},
			series: [{
				name: '数量',
				type: 'pie',
				radius: ['50%', '70%'],
				right: '',
				avoidLabelOverlap: false,
				formatter: '{a}: {b}',
				label: {
					formatter: '{b} ({c})',
					position: 'outside',
					show: true,
					textStyle: {
						color: 'rgba(85, 255, 127, 1)'
					},
					fontSize: '15',
				},
				emphasis: {
					label: {
						show: true,
						fontSize: '20',
						fontWeight: 'bold',
					}
				},
				backgroundColor: '#2c343c',
				textStyle: {
					color: 'rgba(85, 255, 127, 1)'
				},
				data: seriesData.series
			}],
		};
		myChart.setOption(option);
		let a = new Object();
		a.name = myChart;
		a.opt = option;
		a.node = echartNode;
		a.root = seriesData
		this.echartsInstance.push(a)
		return myChart;
	},


	/**
	 * 上下柱形图
	 * @param {Object} echartNode
	 * @param {Object} _this
	 * 
	 */
	initBarechart: function(echartNode, _this) {
		const option = {
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(50,50,50,0.5)',
				borderWidth: '1',
				borderColor: 'rgba(85, 255, 127, 1)',
				textStyle: {
					color: 'rgba(85, 255, 127, 1)',
					fontWeight: 'bold'
				}
			},
			xAxis: {
				type: 'category',
				data: _this.TimePoins,
			},
			yAxis: {
				name: '费用',
				type: 'value',
				// axisLabel: {
				//    	  formatter: (value) => {
				// 	    // 负数取反 显示的就是正数了
				//    	    if (value < 0) return -value
				//         else return value
				//    	  },
				// 	  }
			},
			textStyle: {
				color: _this.style.color
			},
			legend: {
				orient: 'horizontal',
				data: _this.legend_data,
				textStyle: {
					color: _this.style.color
				},
			},
			series: _this.seriesData
		};
		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		let a = new Object();
		a.name = myChart;
		a.opt = option;
		a.node = echartNode;
		a.root = _this
		this.echartsInstance.push(a)
		myChart.setOption(option);
	},


	/**
	 * 树图
	 * @param {Object} echartNode
	 * @param {Object} data
	 * 
	 * data:
	   [
		"name": "flare",
		"children": [
			{
				"name": "data",
				"children": [
					{
						 "name": "converters",
						 "children": [
						  {"name": "Converters", "value": 721},
						  {"name": "DelimitedTextConverter", "value": 4294}
						 ]
					},
					{
						"name": "DataUtil",
						"value": 3322
					}
				]
			}]
			]
	 * 
	 */
	initTree: function(echartNode, data) {
		const option = {
			tooltip: {
				trigger: 'item',
				triggerOn: 'mousemove'
			},
			toolbox: {
				show: "true",
				orient: 'horizontal',
				feature: {
					saveAsImage: {
						show: true,
						title: "保存为图片"
					},
				}
			},
			legend: {
				top: '2%',
				left: '3%',
				orient: 'vertical',
				data: [{
						name: 'mac追踪关系图',
						icon: 'rectangle'
					}
				],
				borderColor: '#c23531'
			},
			series: [{
				type: 'tree',
				name: 'mac追踪关系图',
				data: [data],
				top: '5%',
				left: '7%',
				bottom: '2%',
				right: '60%',
				//标记小圆圈大小
				symbolSize: 20,
				//默认展开深度
				initialTreeDepth: 5,
				//线条相关配置
				lineStyle: {
					color: "#55ffff"
				},
				label: {
					position: 'left',
					verticalAlign: 'middle',
					align: 'right'
				},
				leaves: {
					label: {
						position: 'right',
						verticalAlign: 'middle',
						align: 'left'
					}
				},
				expandAndCollapse: true,
				animationDuration: 550,
				animationDurationUpdate: 750
			}]
		};
		let myChart = echarts.init(document.getElementById(echartNode), 'light');
		myChart.setOption(option)
		myChart.resize();
	},
}
